export default {
  adPerformance: {
    columnTranslation: [
      { from: 'Clicks', to: 'Clicks' },
      { from: 'Impressions', to: 'Impressions'},
      { from: 'Cost', to: 'Cost'},
      { from: 'Conversions', to: 'Conversions'},
      { from: 'All conv. value', to: 'ConversionValue'},

      { from: 'Headline', to: 'Headline'},
      { from: 'Headline 1', to: 'HeadlinePart1'},
      { from: 'Headline 2', to: 'HeadlinePart2'},
      { from: 'Headline 3', to: 'HeadlinePart3'},
      { from: 'Description line 1', to: 'Description1'},
      { from: 'Description line 2', to: 'Description2'},
      { from: 'Description', to: 'Description'},
      { from: 'Display URL', to: 'DisplayUrl'},
      { from: "Final URL", to: "CreativeFinalUrls"},
      { from: "Destination URL", to: "CreativeDestinationUrl"},

      { from: 'Campaign', to: 'CampaignName'},
      { from: 'Ad group', to: 'AdGroupName'}
    ],
    summaryRegex: ["^Total"]
  },
  searchQueryPerformance: {
    columnTranslation: [
      { from: 'Clicks', to: 'Clicks'},
      { from: 'Impressions', to: 'Impressions'},
      { from: 'Cost', to: 'Cost'},
      { from: 'Conversions', to: 'Conversions'},
      { from: 'All conv. value', to: 'ConversionValue'},

      { from: 'Campaign', to: 'CampaignName'},
      { from: 'Ad group', to: 'AdGroupName'},
      { from: 'Search term', to: 'Query'}
    ],
    summaryRegex: ["^Total"]
  }
}



// WEBPACK FOOTER //
// ./src/components/config/initData.js